// extracted by mini-css-extract-plugin
module.exports = {"flex":"ShipingForm_flex__mYHiL","inputLong":"ShipingForm_inputLong__3XTuc","inputShort":"ShipingForm_inputShort__3Xoni"};